// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bx--dropdown-list{height:160px;width:170px}.bx--assistive-text{display:none}.bx--btn--tertiary:focus,.bx--btn.bx--btn--icon-only.bx--tooltip__trigger:focus,.bx--btn.bx--btn--icon-only.bx--tooltip__trigger:focus svg{outline:none!important;outline:0!important}", ""]);
// Exports
module.exports = exports;
